import * as React from "react";
import { Tabs, Tab } from "./styled";

const UsersFilter = () => {
    // value is an integer value representing current tab, 'All'
    const [value, setValue] = React.useState(0);

    /**
     * @param {object} event an event object
     * @param {number} newValue an integer value that represents tab
     */
    const handleChange = (event: any, newValue: number) => {
        setValue(newValue);
    };

    return (
        <Tabs
            value={value}
            onChange={handleChange}
            TabIndicatorProps={{
                style: { backgroundColor: "transparent" },
            }}
        >
            <Tab disableRipple disableFocusRipple label="All" />
        </Tabs>
    );
};
export default UsersFilter;
